import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as svc from "../../api/financeService";

// Expenses
export const fetchExpenses = createAsyncThunk("finance/fetchExpenses", async (params) => {
  const res = await svc.getExpenses(params);
  return res.data;
});
export const createExpenseThunk = createAsyncThunk("finance/createExpense", async (data) => {
  await svc.createExpense(data);
});
export const updateExpenseThunk = createAsyncThunk("finance/updateExpense", async ({ id, data }) => {
  await svc.updateExpense(id, data);
});
export const deleteExpenseThunk = createAsyncThunk("finance/deleteExpense", async (id) => {
  await svc.deleteExpense(id);
  return id;
});

// Income
export const fetchIncomeEntries = createAsyncThunk("finance/fetchIncome", async (params) => {
  const res = await svc.getIncomeEntries(params);
  return res.data;
});
export const createIncomeEntryThunk = createAsyncThunk("finance/createIncome", async (data) => {
  await svc.createIncomeEntry(data);
});
export const updateIncomeEntryThunk = createAsyncThunk("finance/updateIncome", async ({ id, data }) => {
  await svc.updateIncomeEntry(id, data);
});
export const deleteIncomeEntryThunk = createAsyncThunk("finance/deleteIncome", async (id) => {
  await svc.deleteIncomeEntry(id);
  return id;
});

// Journal
export const fetchJournalEntries = createAsyncThunk("finance/fetchJournal", async (params) => {
  const res = await svc.getJournalEntries(params);
  return res.data;
});
export const createJournalEntryThunk = createAsyncThunk("finance/createJournal", async (data) => {
  await svc.createJournalEntry(data);
});
export const updateJournalEntryThunk = createAsyncThunk("finance/updateJournal", async ({ id, data }) => {
  await svc.updateJournalEntry(id, data);
});
export const deleteJournalEntryThunk = createAsyncThunk("finance/deleteJournal", async (id) => {
  await svc.deleteJournalEntry(id);
  return id;
});

// Supplier Advance
export const fetchSupplierAdvances = createAsyncThunk("finance/fetchAdvances", async (params) => {
  const res = await svc.getSupplierAdvances(params);
  return res.data;
});
export const createSupplierAdvanceThunk = createAsyncThunk("finance/createAdvance", async (data) => {
  await svc.createSupplierAdvance(data);
});
export const updateSupplierAdvanceThunk = createAsyncThunk("finance/updateAdvance", async ({ id, data }) => {
  await svc.updateSupplierAdvance(id, data);
});
export const deleteSupplierAdvanceThunk = createAsyncThunk("finance/deleteAdvance", async (id) => {
  await svc.deleteSupplierAdvance(id);
  return id;
});

// Supplier Payments
export const fetchSupplierPayments = createAsyncThunk("finance/fetchPayments", async (params) => {
  const res = await svc.getSupplierPayments(params);
  return res.data;
});
export const createSupplierPaymentThunk = createAsyncThunk("finance/createPayment", async (data) => {
  await svc.createSupplierPayment(data);
});
export const updateSupplierPaymentThunk = createAsyncThunk("finance/updatePayment", async ({ id, data }) => {
  await svc.updateSupplierPayment(id, data);
});

const financeSlice = createSlice({
  name: "finance",
  initialState: {
    expenses: [],
    income: [],
    journal: [],
    advances: [],
    payments: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Expenses
      .addCase(fetchExpenses.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchExpenses.fulfilled, (state, action) => { state.loading = false; state.expenses = Array.isArray(action.payload) ? action.payload : []; })
      .addCase(fetchExpenses.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(deleteExpenseThunk.fulfilled, (state, action) => {
        state.expenses = state.expenses.filter((e) => (e.expenseID ?? e.id) !== action.payload);
      })
      // Income
      .addCase(fetchIncomeEntries.pending, (state) => { state.loading = true; })
      .addCase(fetchIncomeEntries.fulfilled, (state, action) => { state.loading = false; state.income = Array.isArray(action.payload) ? action.payload : []; })
      .addCase(fetchIncomeEntries.rejected, (state) => { state.loading = false; })
      .addCase(deleteIncomeEntryThunk.fulfilled, (state, action) => {
        state.income = state.income.filter((e) => (e.incomeID ?? e.id) !== action.payload);
      })
      // Journal
      .addCase(fetchJournalEntries.pending, (state) => { state.loading = true; })
      .addCase(fetchJournalEntries.fulfilled, (state, action) => { state.loading = false; state.journal = Array.isArray(action.payload) ? action.payload : []; })
      .addCase(fetchJournalEntries.rejected, (state) => { state.loading = false; })
      .addCase(deleteJournalEntryThunk.fulfilled, (state, action) => {
        state.journal = state.journal.filter((e) => (e.journalID ?? e.id) !== action.payload);
      })
      // Advances
      .addCase(fetchSupplierAdvances.pending, (state) => { state.loading = true; })
      .addCase(fetchSupplierAdvances.fulfilled, (state, action) => { state.loading = false; state.advances = Array.isArray(action.payload) ? action.payload : []; })
      .addCase(fetchSupplierAdvances.rejected, (state) => { state.loading = false; })
      .addCase(deleteSupplierAdvanceThunk.fulfilled, (state, action) => {
        state.advances = state.advances.filter((e) => (e.advanceID ?? e.id) !== action.payload);
      })
      // Payments
      .addCase(fetchSupplierPayments.pending, (state) => { state.loading = true; })
      .addCase(fetchSupplierPayments.fulfilled, (state, action) => { state.loading = false; state.payments = Array.isArray(action.payload) ? action.payload : []; })
      .addCase(fetchSupplierPayments.rejected, (state) => { state.loading = false; });
  },
});

export default financeSlice.reducer;
